import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-44a9a84e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "message" }
const _hoisted_2 = {
  key: 0,
  class: "message__text"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_i18n_t = _resolveComponent("i18n-t")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($props.text)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_i18n_t, {
            tag: "span",
            keypath: $props.text
          }, {
            failedLoginTimeout: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.failedLoginTimeout), 1)
            ]),
            newline: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          }, 8, ["keypath"])
        ]))
      : _createCommentVNode("", true)
  ]))
}